const artifactValidationStatuses = {
	PENDING: "pending",
	VALIDATING: "validating",
	FAILED: "failed",
	VALID: "valid",
	INVALID: "invalid",
};

export default artifactValidationStatuses;
